module.exports = __webpack_public_path__ + "img/google_oidc.60721af5.png";